import { r as registerInstance, h, H as Host } from './index-8f7fb048.js';

const marketDividerCss = ":host{display:block;height:var(--divider-height);border-radius:var(--divider-radius);background-color:var(--divider-fill-color)}:host([margin=\"large\"]){margin:var(--divider-large-variant-vertical-padding) 0}:host([margin=\"medium\"]){margin:var(--divider-medium-variant-vertical-padding) 0}:host([margin=\"small\"]){margin:var(--divider-small-variant-vertical-padding) 0}";

const MarketDivider = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.margin = 'medium';
  }
  render() {
    return h(Host, { class: "market-divider" });
  }
};
MarketDivider.style = marketDividerCss;

export { MarketDivider as market_divider };
